import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useContext } from 'react';
import classnames from 'classnames';
import { StickyTableHeader } from './StickyTableHeader.js';
import { TableContext } from './context.js';
import { s as styles } from './table-CLlr1zNv.js';
import 'react-dom';
import './cell-Dr-jPjDU.js';

const DENSITY_TO_CSS = {
    'extra-small': styles.densityExtraSmall,
    small: styles.densitySmall,
    medium: styles.densityMedium,
    large: styles.densityLarge,
};
const TableHeader = ({ divider, density = 'small', 'data-qa': dataQa = 'table-header', children, }) => {
    const theadRef = useRef(null);
    const tableContext = useContext(TableContext);
    const withDivider = divider ?? tableContext.divider;
    return (jsxs(Fragment, { children: [jsx("thead", { ref: theadRef, className: classnames(styles.header, DENSITY_TO_CSS[density], {
                    [styles.withDivider]: !!withDivider,
                }), "data-qa": dataQa, children: children }), tableContext.stickyHeader && tableContext.headerNode && (jsx(StickyTableHeader, { root: tableContext.headerNode, headerRef: theadRef, divider: withDivider, density: density, children: children }))] }));
};

export { TableHeader };
//# sourceMappingURL=TableHeader.js.map
